import { resultsMenu } from './results-header';
import { resultsList } from './results-list';
export const resultsSection = () => {
    const result = document.createElement('results-section');
    result.style.maxWidth = '800px';
    result.className = 'page-container';
    result.append(resultsMenu(), resultsList());
    return result;
};
